import { useEffect, useState } from "react";

import moment from "moment";

import { utmKeys } from "../../utils/const";

export const useUTMParams = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);

  const utmUrlParams = utmKeys.reduce((acc, key) => {
    acc[key] = urlSearchParams.get(key);
    return acc;
  }, {});

  const [utmParams, setUtmParams] = useState({});

  useEffect(() => {
    const timeWrite = localStorage.getItem("timeWrite");

    if (timeWrite) {
      const parseTimeWrite = moment(timeWrite)
        .add(1, "day")
        .format("DD.MM.YYYY HH:mm:ss");
      const now = moment(new Date()).format("DD.MM.YYYY HH:mm:ss");

      if (parseTimeWrite < now) {
        utmKeys.forEach((utmParamsName) => {
          localStorage.removeItem(utmParamsName);
        });
        localStorage.removeItem("timeWrite");
      }
    }

    // ==============================================================

    let oneUtmParamExist = false;

    for (const utmParam in utmUrlParams) {
      const value = utmUrlParams[utmParam];
      if (!value) {
        continue;
      }
      oneUtmParamExist = true;
      localStorage.setItem(utmParam, value);
    }

    if (oneUtmParamExist) {
      localStorage.setItem("timeWrite", moment(new Date()).format());
    }
  }, []);

  useEffect(() => {
    const utmParams = utmKeys.reduce((acc, key) => {
      acc[key] = localStorage.getItem(key);
      return acc;
    }, {});
    setUtmParams(utmParams);
  }, []);

  const clearUtmParams = () => {
    utmKeys.forEach((utmKey) => {
      localStorage.removeItem(utmKey);
    });
    localStorage.removeItem("timeWrite");
  };

  return { utmParams, clearUtmParams };
};
